export default "__VITE_ASSET__D32YEUzV__"